import './suppressErrors'; // ← Add this as FIRST import
import './sentry'; // initialize Sentry as early as possible
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App/App";
import "./i18n";
import { HelmetProvider } from "react-helmet-async";

// Importing the Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
import { UserProvider } from "../src/Contexts/UserContext"

console.log('Error Overlay Setting:', process.env.REACT_APP_DISABLE_ERROR_OVERLAY);
console.log('NODE_ENV:', process.env.NODE_ENV);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <HelmetProvider>
    <React.Fragment>
      <UserProvider>
        <App />
      </UserProvider>
    </React.Fragment>
  </HelmetProvider>
);

